window.initAutocomplete = function () {
  const personalizeFlow = document.querySelector("personalize-flow");
  if (
    personalizeFlow &&
    typeof personalizeFlow.initLocationAutocomplete === "function"
  ) {
    personalizeFlow.initLocationAutocomplete();
  }
};

if (!customElements.get("personalize-flow")) {
  customElements.define(
    "personalize-flow",
    class PersonalizeFlow extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.personalizeBlock = document.querySelector("#personalize-block");
        this.personalizeOpenButton = document.querySelector(
          "#personalize-open-btn"
        );
        this.personalizeCloseButton = document.querySelector(
          "#personalize-close-btn"
        );
        this.personalizeForm = document.querySelector("#personalize-form");
        this.resultBackButton = document.querySelector(
          "#personalize-result-back-btn"
        );
        this.heroContent = document.querySelector("#product-hero-content");
        this.personalizeResultBlock = document.querySelector(
          "#personalize-result"
        );
        this.personaliseAddToCartBtn = document.querySelector(
          "#personalize-add-to-cart-btn"
        );
        this.loader = document.querySelector("#personalize-loader");

        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      connectedCallback() {
        if (this.personalizeBlock) {
          this.personalizeOpenButton.addEventListener("click", () =>
            this.openPersonalizeModal()
          );
          this.personalizeCloseButton.addEventListener("click", () =>
            this.closePersonalizeModal()
          );
          this.personalizeForm.addEventListener("submit", (e) =>
            this.personalizeFormSubmit(e)
          );
          this.resultBackButton.addEventListener("click", () =>
            this.showPersonalizeBlock()
          );
          this.personaliseAddToCartBtn.addEventListener("click", () =>
            this.form.requestSubmit()
          );
          this.watchEventNameChange();
          this.watchStandardInputs();
          this.watchCustomSelects();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const payload = {};

        const bundleProp = formData.get("properties[_bundle]");

        if (bundleProp) {
          payload.properties = {
            _bundle: bundleProp,
          };
        }

        if (
          this.personalizeProperties &&
          Object.keys(this.personalizeProperties).length > 0
        ) {
          payload.properties = {
            ...this.personalizeProperties,
          };
        }

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant({ id: variantId }, quantity, payload, {
          ensureUnique: this.dataset.ensureUnique === "true",
        }).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }

      openPersonalizeModal() {
        this.personalizeBlock.classList.remove("hidden");
        this.heroContent.classList.add("hidden");
      }

      closePersonalizeModal() {
        this.personalizeBlock.classList.add("hidden");
        this.heroContent.classList.remove("hidden");
      }

      personalizeFormSubmit(e) {
        e.preventDefault();
        if (!this.validatePersonalizeForm()) return;

        const formData = new FormData(e.target);
        const json = Object.fromEntries(formData.entries());
        const transformed = this.transformData(json);

        this.personalizeProperties = transformed;
        this.onShowBookPreview(e);
        this.renderResultMarkup(json);
      }

      transformData(data) {
        const {
          _eventYear,
          _eventMonth,
          _eventDay,
          _firstPersonMonth,
          _firstPersonDay,
          _secondPersonMonth,
          _secondPersonDay,
          ...rest
        } = data;

        return {
          ...rest,
          _eventDate: this.buildEventDate(_eventYear, _eventMonth, _eventDay),
          _person1Zodiac: this.getZodiacSign(
            _firstPersonMonth,
            _firstPersonDay
          ),
          _person2Zodiac: this.getZodiacSign(
            _secondPersonMonth,
            _secondPersonDay
          ),
        };
      }

      buildEventDate = (year, month, day, delimiter = "-", format = "YMD") => {
        if (!year || !month || !day) return "";

        if (format === "MDY") {
          return `${month}${delimiter}${day}${delimiter}${year}`;
        }

        return `${year}${delimiter}${month}${delimiter}${day}`;
      };

      getZodiacSign = (month, day) => {
        if (!month || !day) return "";

        const m = parseInt(month, 10);
        const d = parseInt(day, 10);

        const zodiacRanges = [
          { sign: "Capricorn", start: [12, 22], end: [1, 19] },
          { sign: "Aquarius", start: [1, 20], end: [2, 18] },
          { sign: "Pisces", start: [2, 19], end: [3, 20] },
          { sign: "Aries", start: [3, 21], end: [4, 19] },
          { sign: "Taurus", start: [4, 20], end: [5, 20] },
          { sign: "Gemini", start: [5, 21], end: [6, 20] },
          { sign: "Cancer", start: [6, 21], end: [7, 22] },
          { sign: "Leo", start: [7, 23], end: [8, 22] },
          { sign: "Virgo", start: [8, 23], end: [9, 22] },
          { sign: "Libra", start: [9, 23], end: [10, 22] },
          { sign: "Scorpio", start: [10, 23], end: [11, 21] },
          { sign: "Sagittarius", start: [11, 22], end: [12, 21] },
        ];

        for (const zodiac of zodiacRanges) {
          const [startMonth, startDay] = zodiac.start;
          const [endMonth, endDay] = zodiac.end;

          const afterStart =
            m > startMonth || (m === startMonth && d >= startDay);
          const beforeEnd = m < endMonth || (m === endMonth && d <= endDay);

          if (startMonth > endMonth) {
            if (afterStart || beforeEnd) return zodiac.sign;
          } else {
            if (afterStart && beforeEnd) return zodiac.sign;
          }
        }

        return "";
      };

      validateCustomSelects() {
        const requiredHiddenInputs = this.personalizeForm.querySelectorAll(
          'input[type="hidden"][required]'
        );
        let isValid = true;

        requiredHiddenInputs.forEach((input) => {
          const wrapper = input.closest(".custom-select");

          if (!input.value.length) {
            isValid = false;
            wrapper.classList.add("custom-select--error");
          } else {
            wrapper.classList.remove("custom-select--error");
          }
        });

        return isValid;
      }

      watchCustomSelects() {
        const customSelects =
          this.personalizeForm.querySelectorAll(".custom-select");

        customSelects.forEach((selectWrapper) => {
          const options = selectWrapper.querySelectorAll(".select-option");

          if (options.length === 0) return;

          options.forEach((option) => {
            option.addEventListener("click", () => {
              selectWrapper.classList.remove("custom-select--error");
            });
          });
        });
      }

      validateStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        let isValid = true;

        fields.forEach((field) => {
          const value = field.value.trim();
          if (!value.length) {
            isValid = false;
            field.classList.add("input--error", "border-[#ff564f]");
          } else {
            field.classList.remove("input--error", "border-[#ff564f]");
          }
        });

        return isValid;
      }

      watchStandardInputs() {
        const fields = this.personalizeForm.querySelectorAll(
          'input[required]:not([type="hidden"]), textarea[required], select[required]'
        );

        fields.forEach((field) => {
          field.addEventListener("input", () => {
            field.classList.remove("input--error", "border-[#ff564f]");
          });
        });
      }

      validatePersonalizeForm() {
        const isStandardValid = this.validateStandardInputs();
        const isCustomSelectsValid = this.validateCustomSelects();
        const isLocationValid = this.validateLocationSelection();

        return isStandardValid && isCustomSelectsValid && isLocationValid;
      }

      validateLocationSelection() {
        const input = document.getElementById("autocomplete");
        const errorMessage = document.getElementById("autocomplete-error");

        const isLocationValid =
          this.selectedCoordinates &&
          this.selectedCoordinates.lat &&
          this.selectedCoordinates.lng;

        if (!isLocationValid && input) {
          input.classList.add("input--error", "border-[#ff564f]");
          if (errorMessage) errorMessage.classList.remove("hidden");
        } else {
          input.classList.remove("input--error", "border-[#ff564f]");
          if (errorMessage) errorMessage.classList.add("hidden");
        }

        return isLocationValid;
      }

      watchEventNameChange() {
        const milestoneInput = this.personalizeForm.querySelector(
          'input[name="_eventName"]'
        );
        const otherTextarea =
          this.personalizeForm.querySelector("#eventOtherVersion");
        const otherEventBlock = this.personalizeForm.querySelector(
          "#event-other-version-block"
        );
        const options = milestoneInput
          .closest(".custom-select")
          .querySelectorAll(".select-option");
        const charCount = this.personalizeForm.querySelector("#char-count");

        if (!milestoneInput || !otherTextarea || options.length === 0) return;

        options.forEach((option) => {
          option.addEventListener("click", () => {
            const selectedValue = option.dataset.value.trim().toLowerCase();

            if (
              selectedValue === "other" ||
              selectedValue == "write your own milestone"
            ) {
              otherEventBlock.classList.remove("hidden");
              otherTextarea.setAttribute("required", true);

              if (otherTextarea.value.trim().length) {
                milestoneInput.value = otherTextarea.value.trim();
              } else {
                milestoneInput.value = "Other";
              }
            } else {
              otherEventBlock.classList.add("hidden");
              otherTextarea.removeAttribute("required");
              milestoneInput.value = selectedValue;
              otherTextarea.value = "";
            }
          });
        });

        if (otherTextarea && charCount) {
          const updateCharCount = () => {
            const count = otherTextarea.value.length;
            charCount.textContent = `Characters Used: ${count} / ${otherTextarea.getAttribute(
              "maxlength"
            )}`;
          };

          const updateMilestoneInput = () => {
            milestoneInput.value = otherTextarea.value.trim();
          };

          updateCharCount();
          otherTextarea.addEventListener("input", () => {
            updateCharCount();
            updateMilestoneInput();
          });
        }
      }

      async onShowBookPreview(e) {
        e.preventDefault();
        const button = document.querySelector("#show-result-btn");
        const errorBox = document.querySelector("#personalize-error-message");

        button.disabled = true;
        button.classList.add("loading");
        const originalText = button.innerHTML;
        button.innerHTML = "Loading...";
        document.body.classList.add("lock");
        this.loader.classList.remove("!hidden");

        const formData = new FormData(this.personalizeForm);
        const json = Object.fromEntries(formData.entries());
        const transformed = this.transformData(json);
        const cleanedParams = this.cleanParams(transformed);
        const requiredKeys = [
          "person1Name",
          "person1Zodiac",
          "person2Name",
          "person2Zodiac",
          "eventName",
          "eventDate",
          "eventLocationName",
        ];
        const params = {};

        const uiReset = () => {
          this.showPersonalizeResult();
          button.disabled = false;
          button.classList.remove("loading");
          button.innerHTML = originalText;
          this.loader.classList.add("!hidden");
          document.body.classList.remove("lock");
        };

        for (const key of requiredKeys) {
          if (!cleanedParams[key]) {
            console.warn(`Missing required param: ${key}`);
          }
          params[key] = cleanedParams[key] || "";
        }

        const paramsString = JSON.stringify(params);

        if (this.lastPreviewParams === paramsString) {
          uiReset();
          return;
        }

        this.lastPreviewParams = paramsString;

        const queryString = new URLSearchParams(params).toString();
        const url = `https://api.fiocompanies.com/v1/products/couples-book/preview?${queryString}`;

        try {
          const previewImages = await this.getPreviewImages(url);

          window.addDynamicSlides(previewImages);
          window.addSlidesToProductModal(previewImages);
        } catch (error) {
          if (errorBox) {
            errorBox.classList.remove("hidden");
            setTimeout(() => {
              errorBox.classList.add("hidden");
            }, 8000);
          }
          console.error("Failed to load preview image:", error.message);
        } finally {
          uiReset();
        }
      }

      async getPreviewImages(url) {
        const response = await fetch(url);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "Failed to fetch preview image");
        }

        const data = await response.json();

        return data.images;
      }

      cleanParams(obj) {
        const cleaned = {};
        for (const key in obj) {
          if (key.startsWith("_")) {
            cleaned[key.substring(1)] = obj[key];
          } else {
            cleaned[key] = obj[key];
          }
        }
        return cleaned;
      }

      renderResultMarkup(personalizeProperties) {
        const {
          _eventName,
          _eventYear,
          _eventMonth,
          _eventDay,
          _eventLocationName,
          _person1Name,
          _firstPersonDay,
          _firstPersonMonth,
          _person2Name,
          _secondPersonDay,
          _secondPersonMonth,
        } = personalizeProperties;

        const eventName =
          this.personalizeResultBlock.querySelector("#result-event");
        const eventDate =
          this.personalizeResultBlock.querySelector("#result-date");
        const location =
          this.personalizeResultBlock.querySelector("#result-location");
        const firstPersonName = this.personalizeResultBlock.querySelector(
          "#result-first-person-name"
        );
        const firstPersonDate = this.personalizeResultBlock.querySelector(
          "#result-first-person-date"
        );
        const secondPersonName = this.personalizeResultBlock.querySelector(
          "#result-second-person-name"
        );
        const secondPersonDate = this.personalizeResultBlock.querySelector(
          "#result-second-person-date"
        );
        const delimeter = "/";
        const format = "MDY";

        if (eventName) eventName.textContent = _eventName;
        if (location) location.textContent = _eventLocationName;
        if (eventDate)
          eventDate.textContent = this.buildEventDate(
            _eventYear,
            _eventMonth,
            _eventDay,
            delimeter,
            format
          );
        if (firstPersonName) firstPersonName.textContent = _person1Name;
        if (firstPersonDate)
          firstPersonDate.textContent = `${_firstPersonMonth}/${_firstPersonDay}`;
        if (secondPersonName) secondPersonName.textContent = _person2Name;
        if (secondPersonDate)
          secondPersonDate.textContent = `${_secondPersonMonth}/${_secondPersonDay}`;
      }

      showPersonalizeResult() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.remove("!hidden");
        this.personalizeBlock.classList.add("!hidden");
        this.heroContent.classList.add("hidden");
      }

      showPersonalizeBlock() {
        if (!this.personalizeResultBlock) return;

        this.personalizeResultBlock.classList.add("!hidden");
        this.personalizeBlock.classList.remove("!hidden");
      }

      initLocationAutocomplete() {
        const input = document.getElementById("autocomplete");
        if (!input) return;

        this.isPlaceSelected = false;

        this.autocomplete = new google.maps.places.Autocomplete(input, {
          types: ["(cities)"],
          fields: ["geometry", "address_components", "formatted_address"],
        });

        this.autocomplete.addListener("place_changed", () => {
          const place = this.autocomplete.getPlace();

          if (!place.geometry || !place.geometry.location) {
            console.warn("No geometry available for selected place.");
            this.isPlaceSelected = false;
            return;
          }

          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          this.selectedCoordinates = { lat, lng };
          this.isPlaceSelected = true;

          document.querySelector('input[name="_eventLocationLatitude"]').value =
            lat;
          document.querySelector(
            'input[name="_eventLocationLongitude"]'
          ).value = lng;
        });

        input.addEventListener("input", () => {
          this.isPlaceSelected = false;
          this.selectedCoordinates = null;

          const errorMessage = document.getElementById("autocomplete-error");
          if (errorMessage) errorMessage.classList.add("hidden");
          input.classList.remove("input--error", "border-[#ff564f]");
        });
      }
    }
  );
}